import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvConfigurationService } from './envconf.service';
import { Observable } from 'rxjs';
import {SeasonalityResponse} from "../models/seasonality-response";
import {SeasonalityWithSize} from "../models/seasonalityWithSize";

@Injectable({
  providedIn: 'root'
})
export class SeasonalityService {

  endpoint: string = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/sites/seasonality`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Get seasonality and sizes for a given site
   * @param siteId
   */
  getSeasonalityAndSizes(siteId: number): Observable<SeasonalityWithSize> {
    return this.http.get<SeasonalityWithSize>(`${this.endpoint}?siteId=${siteId}`);
  }

  /**
   * Recompute seasonality for a given site and included years
   * @param siteId
   * @param includedYears
   */
  recomputeSeasonality(siteId: number, includedYears: number[]): Observable<SeasonalityResponse> {
    return this.http.post<SeasonalityResponse>(`${this.endpoint}/recompute`, { siteId, includedYears });
  }

  /**
   * Save seasonality for a given site, sizes and months
   * @param payload
   */
  saveSeasonality(payload: { siteId: number; sizes: string[]; months: (number | null)[]; }) {
    return this.http.post(`${this.endpoint}/save`, payload);
  }

  /**
   * Recalculate forecast for a given site
   * @param siteId
   */
  recalculateForecast(siteId: number) {
    return this.http.post(`${this.endpoint}/saveandrecalculate`, { siteId });
  }
}
